// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-container {
    background-color: #f9f9f9;
    max-width: 740px;
    margin: 40px auto;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    color: #333;
    font-family: 'Source Sans Pro', serif;;
}

.post-title {
    font-size: 28px;
    color: #333;
    margin-bottom: 8px;
    font-family: 'Merriweather', sans-serif;
}

.post-meta {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
    font-family: 'Merriweather', sans-serif;
}

.author-name {
    font-weight: bold;
    color: #2c4f61;
}

.post-date {
    font-style: italic;
}

.post-content {
    font-size: 20px;
    line-height: 1.6;
}

.post-content p {
    margin-bottom: 20px;
}

.post-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px 0;
    border-radius: 8px;
}

hr {
    border: none; /* Remove default border */
    height: 2px; /* Set height of the line */
    background-color: #ccc; /* Set color of the line */
    margin: 20px 0; /* Add margin for spacing */
  }

/* Only apply when it's a journal post */
.journal-post #comments,
.journal-post .blogextras-comments {
  font-family: 'Georgia', serif;
  background-color: #fdfaf6;
  color: #3a3a3a;
  border-radius: 12px;
  padding-top: 1rem;
}

.journal-post p{
    margin-right: 1rem;
}


.journal-post .blogextras-comments h2,
.journal-post .blogextras-comments h3 {
  font-family: 'Georgia', serif;
  font-size: 1.3rem;
  color: #2f2f2f;
  margin-top: 2rem;
}

.journal-post .blogextras-comments input,
.journal-post .blogextras-comments textarea {
  background: #fffdf9;
  border: 1px solid #e0dbd4;
  font-family: 'Georgia', serif;
  font-size: 1rem;
  color: #3a3a3a;
  border-radius: 6px;
  padding: 0.5rem;
  transition: border-color 0.2s ease;
}

.journal-post > .post-content{
    font-size: 'medium' !important;
}

.journal-post .blogextras-comments input:focus,
.journal-post .blogextras-comments textarea:focus {
  border-color: #d6cfc4;
  outline: none;
  box-shadow: 0 0 0 2px rgba(221, 210, 197, 0.3);
}

.journal-post .blogextras-comments button {
  background-color: #e5e0d8 !important;
  color: #3a3a3a !important;
  border: none;
  border-radius: 6px;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transition: background 0.3s ease;
}

.journal-post .blogextras-comments button:hover {
  background-color: #dcd6ce !important;
}


.journal-post,
.journal-post input,
.journal-post textarea,
.journal-post button {
  font-family: 'IBM Plex Mono', monospace !important;
  line-height: 1.6;
  letter-spacing: -0.01em;    /* Slightly tighter tracking */
  color: #3a3a3a;
}
  
.image-slider {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 1rem 0;
    scrollbar-width: thin;
  }
  
  .image-slider::-webkit-scrollbar {
    height: 6px;
  }
  
  .image-slider::-webkit-scrollbar-thumb {
    background: #d2c7ba;
    border-radius: 4px;
  }
  
  .slide-track {
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  
  .slide-track img {
    border-radius: 12px;
    max-height: 320px;
    object-fit: cover;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  }

  .journal-post .post-content {
    font-size: 0.88rem !important;
    line-height: 1.65;
  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/Post.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,WAAW,EAAE,2BAA2B;IACxC,sBAAsB,EAAE,0BAA0B;IAClD,cAAc,EAAE,2BAA2B;EAC7C;;AAEF,wCAAwC;AACxC;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;;;;EAIE,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB,KAAK,8BAA8B;EAC1D,cAAc;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,0CAA0C;EAC5C;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;EACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600&display=swap');\n\n.post-container {\n    background-color: #f9f9f9;\n    max-width: 740px;\n    margin: 40px auto;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n    color: #333;\n    font-family: 'Source Sans Pro', serif;;\n}\n\n.post-title {\n    font-size: 28px;\n    color: #333;\n    margin-bottom: 8px;\n    font-family: 'Merriweather', sans-serif;\n}\n\n.post-meta {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 20px;\n    font-family: 'Merriweather', sans-serif;\n}\n\n.author-name {\n    font-weight: bold;\n    color: #2c4f61;\n}\n\n.post-date {\n    font-style: italic;\n}\n\n.post-content {\n    font-size: 20px;\n    line-height: 1.6;\n}\n\n.post-content p {\n    margin-bottom: 20px;\n}\n\n.post-content img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    margin: 20px 0;\n    border-radius: 8px;\n}\n\nhr {\n    border: none; /* Remove default border */\n    height: 2px; /* Set height of the line */\n    background-color: #ccc; /* Set color of the line */\n    margin: 20px 0; /* Add margin for spacing */\n  }\n\n/* Only apply when it's a journal post */\n.journal-post #comments,\n.journal-post .blogextras-comments {\n  font-family: 'Georgia', serif;\n  background-color: #fdfaf6;\n  color: #3a3a3a;\n  border-radius: 12px;\n  padding-top: 1rem;\n}\n\n.journal-post p{\n    margin-right: 1rem;\n}\n\n\n.journal-post .blogextras-comments h2,\n.journal-post .blogextras-comments h3 {\n  font-family: 'Georgia', serif;\n  font-size: 1.3rem;\n  color: #2f2f2f;\n  margin-top: 2rem;\n}\n\n.journal-post .blogextras-comments input,\n.journal-post .blogextras-comments textarea {\n  background: #fffdf9;\n  border: 1px solid #e0dbd4;\n  font-family: 'Georgia', serif;\n  font-size: 1rem;\n  color: #3a3a3a;\n  border-radius: 6px;\n  padding: 0.5rem;\n  transition: border-color 0.2s ease;\n}\n\n.journal-post > .post-content{\n    font-size: 'medium' !important;\n}\n\n.journal-post .blogextras-comments input:focus,\n.journal-post .blogextras-comments textarea:focus {\n  border-color: #d6cfc4;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(221, 210, 197, 0.3);\n}\n\n.journal-post .blogextras-comments button {\n  background-color: #e5e0d8 !important;\n  color: #3a3a3a !important;\n  border: none;\n  border-radius: 6px;\n  padding: 0.6rem 1.2rem;\n  font-size: 1rem;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  transition: background 0.3s ease;\n}\n\n.journal-post .blogextras-comments button:hover {\n  background-color: #dcd6ce !important;\n}\n\n\n.journal-post,\n.journal-post input,\n.journal-post textarea,\n.journal-post button {\n  font-family: 'IBM Plex Mono', monospace !important;\n  line-height: 1.6;\n  letter-spacing: -0.01em;    /* Slightly tighter tracking */\n  color: #3a3a3a;\n}\n  \n.image-slider {\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 1rem 0;\n    scrollbar-width: thin;\n  }\n  \n  .image-slider::-webkit-scrollbar {\n    height: 6px;\n  }\n  \n  .image-slider::-webkit-scrollbar-thumb {\n    background: #d2c7ba;\n    border-radius: 4px;\n  }\n  \n  .slide-track {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n  }\n  \n  .slide-track img {\n    border-radius: 12px;\n    max-height: 320px;\n    object-fit: cover;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);\n  }\n\n  .journal-post .post-content {\n    font-size: 0.88rem !important;\n    line-height: 1.65;\n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
